class BlogPostsFeed extends HTMLElement {
  constructor() {
    super()
    this.categoryTriggers = this.querySelectorAll('.js-category-trigger')
    this.container = this.querySelector('.js-blog-feed-container')
  }

  connectedCallback() {
    this._attacEvents()
  }

  _attacEvents() {
    if (this.categoryTriggers.length) {
      Array.from(this.categoryTriggers).forEach((el) => {
        let trigger = el.querySelector('a')

        trigger.addEventListener('click', (event) => {
          event.preventDefault()

          const categoryName = trigger.dataset.category
          let url = `${window.location.href}/tagged/${categoryName}?page=1&view=filtered`

          if (categoryName === 'all') {
            url = `${window.location.href}?page=1&view=filtered`
          }

          this.removeActiveClass()
          trigger.classList.add('is-active')
          this.fetchData(url)
        })
      })
    }
  }

  removeActiveClass() {
    Array.from(this.categoryTriggers).forEach((el) => {
      el.querySelector('a').classList.remove('is-active')
    })
  }

  fetchData(url) {
    fetch(url)
      .then((response) => {
        return response.text()
      })
      .then((html) => {
        const parser = new DOMParser()
        const parsedDocument = parser.parseFromString(html, 'text/html')
        const target = parsedDocument.querySelector('.js-blog-feed-container')

        this.container.innerHTML = target.innerHTML
      })
      .catch(function (err) {
        console.warn('Something went wrong.', err)
      })
  }
}

customElements.define('blog-post-feed', BlogPostsFeed)
